import { HEADER_FOOTER_LOADING, HEADER_FOOTER_ERROR, HEADER_FOOTER_SUCCESS } from "./types";
const initState = { loading: true, error: false, blogs: [] };
const headerFooterReducer = (state = initState, action) => {
    switch (action.type) {
        case HEADER_FOOTER_LOADING:
            return { ...state, loading: true };
        case HEADER_FOOTER_ERROR:
            return { ...state, loading: false, error: true };
        case HEADER_FOOTER_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                headerFooter: action.payload,
            };
        default:
            return state;
    }
};

export { headerFooterReducer };
